import React, { Fragment } from "react";
import { Title, CharacterImage, Card, CardBody } from "./elements";
import Button from "components/common/button";

const History = ({ history, selectCharacter }) => (
  <Fragment>
    <Title>History</Title>
    {history.map((character, index) => (
      <Card marginB="20">
        <CharacterImage src={character.image} />
        <CardBody>
          {character.name}
          <Button
            onClick={() => selectCharacter(index)}
            variant="outlined"
            color="secondary"
          >
            View
          </Button>
        </CardBody>
      </Card>
    ))}
  </Fragment>
);

export default History;
